/**
 * Shared access types from authorization mutation errors. Remediation describes
 * intent (what to fix), not platform-specific routes — web maps actions to its own navigation.
 * Blockers list order is ranking; the first item is the summary.
 */
export type AccessRemediation = {
  action: string;
  context: Record<string, unknown>;
};

export type AccessBlocker = {
  reasonCode: string;
  message: string;
  remediation: AccessRemediation;
};

export const VERIFY_EMAIL_ACTION = 'verify_email';
export const TRY_AGAIN_ACTION = 'try_again';
export const EMAIL_UNVERIFIED_REASON = 'email_unverified';
